import * as Yup from "yup";
import { APP_CONFIG } from "../../../constants/constants";
import { yupTestCheckFileSize, yupTestCheckFileType } from "../../../utils/validation";

// form field names
export type TFormFieldNames = "name" | "file";

// initial values for the form
export const formInitialValues = {
  name: "",
  file: null,
};

// validation schema for the form
export const YupValidationSchema = Yup.object().shape({
  name: Yup.string()
    .required("Please enter the name of document"),

  file:
    Yup
      .mixed<File>()
      .required('File is required')
      .test(
        'is-correct-file',
        'VALIDATION_FIELD_FILE_BIG',
        yupTestCheckFileSize
      )
      .test(
        'is-big-file',
        'VALIDATION_FIELD_FILE_WRONG_TYPE',
        yupTestCheckFileType
      ),
});